import {authAxios} from "lib/http/http.common"
import {UserInfo} from "dto/auth/Authentication"
import {ApiResponse} from "api/common/response"

const findUserInfo = async (accessToken: string) => {
    const response = await authAxios.get<ApiResponse<UserInfo>>('/auth/userinfo', {
        headers: {
            "Authorization": `Bearer ${accessToken}`
        }
    })
    return response.data
}

export const AuthApi = {
   findUserInfo
}